import { eventChannel, END } from "redux-saga";
import { put, call, take, takeEvery } from "redux-saga/effects";
// import cookie from "react-cookies";
import { SOCKET_RECEIVED, SOCKET_CONNECT, SOCKET_CLOSE, SOCKET_SEND } from "../actionTypes";
import { WebsocketProps } from "../reducers/websocket";

let ws; // define it here so it's available in return function
setInterval(() => ws && ws.readyState === 1 && ws.send("{}"), 2000);

function createEventChannel() {
  return eventChannel((emit) => {
    console.log(ws);
    if (ws && (ws.readyState === 1 || ws.readyState === 2)) {
      return () => {
        console.log("Closing Websocket");
        ws.close();
      };
    }
    function createWs() {
      // Subscribe to websocket
      const token = sessionStorage.getItem("token");
      // cookie.save("___USER_Token", token);
      if (!WebSocket) {
        console.log("#浏览器不支持websocket");
        return;
      }
      // ?token=${encodeURIComponent(token)}
      if (!token || !token.length) {
        return;
      }
      ws = new WebSocket(`ws://${window.location.host}/event`);
      ws.onopen = () => {
        console.log("Opening Websocket");
        ws.send(`token:${encodeURIComponent(token)}`);
        const t: WebsocketProps = {
          type: "getWsStatus",
          status: true,
        };
        return emit(t);
      };
      ws.onerror = (error) => {
        console.log("ERROR: ", error);
      };
      ws.onmessage = (e) => {
        console.log(ws, e);
        const { data } = e;
        if (data === "token:ok") {
          console.log("验证成功！");
          const t: WebsocketProps = {
            type: "getWsStatus",
            status: true,
          };
          return emit(t);
        }
        let obj = {};
        try {
          obj = JSON.parse(e.data);
        } catch (e) {
          console.error(e);
        }
        return emit(obj);
      };
      ws.onclose = (e) => {
        const t: WebsocketProps = {
          type: "getWsStatus",
          status: false,
        };
        emit(t);
        if (e.code === 1005) {
          console.log("WebSocket: closed");
          // you probably want to end the channel in this case
          emit(END);
        } else {
          console.log(
            "Socket is closed Unexpectedly. Reconnect will be attempted in 3 second.",
            e.reason,
          );
          setTimeout(() => {
            createWs();
          }, 3000);
        }
      };
    }
    createWs();
    return () => {
      console.log("Closing Websocket");
      ws.close();
    };
  });
}
function* internalListener(action) {
  if (ws) {
    if (ws.readyState === 1) {
      ws.send(action.payload);
      yield;
    } else if (ws.readyState === 2) {
      console.log("连接中");
      yield;
    }
  } else {
    console.log("未连接");
    yield;
  }
}
function* close() {
  console.log("-------  websocket close");
  if (ws) ws.close();
  yield;
}
function* initializeWebSocketsChannel() {
  console.log("-------  websocket init");
  const channel = yield call(createEventChannel);
  while (true) {
    const message = yield take(channel);
    console.log(message);
    yield put({ type: SOCKET_RECEIVED, payload: message });
  }
}
export function* websocket() {
  console.log("----------websocket init");
  yield* [
    takeEvery(SOCKET_SEND, internalListener),
    takeEvery(SOCKET_CLOSE, close),
    takeEvery(SOCKET_CONNECT, initializeWebSocketsChannel),
  ];
}
